import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';

import { asyncConnectMostRead } from 'modules/Common/reducers/morenews';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import MostReadPanel from '../components/MostReadPanel';

@layoutAsyncConnect(
  "MostReadAll",
  asyncConnectMostRead(/* all */)
)
@catchLifeCycleErrors
export default class MostReadAll extends Component {
  static propTypes = {
    mostread: PropTypes.array
  };

  render() {
    return <MostReadPanel articles={this.props.mostread} showCategory />;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/MostReadAll.js